module.exports = __webpack_public_path__ + "static/media/hipercard.1cab3de3.svg";